import {crmStore} from '@components/crm/crm-store'
import {globals} from '@extensions/globals-base'
import {Project} from '@extensions/project'
import {CbProps} from './types'

export const getProjects = (): CbProps[] => {
  const companyId = globals.getCompanyId()
  const allProjects = Project.listProjects(companyId, 'not-archive')
    .filter(p => !crmStore.isCrmProject(p))
    .sort(Project.projectOrderComparer)
    .map(({id, title}) => ({id, title}))

  return allProjects
}
